import type { OptionProps } from './const';
import { cn } from '@utils';
import { IconCheck } from '@wegic/icon';
import { memo } from 'react';
import './index.less';

export const Option = memo<OptionProps>((props) => {
  const { label, value, active, disabled, onClick, children, className, style, ...rest } = props;

  return (
    <div
      className={cn(
        'wg-select__option',
        {
          'wg-select__option--active': active,
          'wg-select__option--disabled': disabled,
        },
        className,
      )}
      style={style}
      onClick={onClick}
      data-value={value}
      {...rest}
    >
      <div className="wg-select__option-label">{children || <span>{label}</span>}</div>
      <div className="wg-select__option-check">{active && <IconCheck />}</div>
    </div>
  );
});

Option.displayName = 'Option';
